$(document).ready(function () {
	$('[data-tom-select]').each(function () {
		const noResultsText = window.appConfig.form.select.noResults || 'No results found';
		const select = this;
		const $select = $(select);

		new TomSelect(select, {
			create: false,
			allowEmptyOption: true,
			placeholder: window.appConfig.form.select.placeholder || 'Select',
			render: {
				no_results: function () {
					return `<div class="no-results">${noResultsText}</div>`;
				},
			},
			onChange: function () {
				$select.trigger('change');
			},
			onBlur: function () {
				$select.trigger('change');
			},
			onDropdownClose: function () {
				$select.trigger('change');
			},
		});

		if ($select.val() === "" || $select.val() === null) {
			select.tomselect.clear(true);
		}
	}).on('change', function () {
		const select = this;
		const $select = $(select);

		if ($select.val() === "" || $select.val() === null) {
			select.tomselect.clear(true);
		}
	});
});
